import { deobfuscateString } from '../../../../utils/obfuscation-utils';
import { loyaltyDomainStore } from '../../store';
export const getEmailAvailability = async () => {
    const { emailAvailability } = loyaltyDomainStore.data;
    if (!emailAvailability)
        return;
    const { lastValidatedEmail, isAvailable } = emailAvailability;
    const deobfuscatedEmail = await deobfuscateString(lastValidatedEmail);
    return {
        lastValidatedEmail: deobfuscatedEmail,
        isAvailable
    };
};
//# sourceMappingURL=get-email-availability.js.map